import React from 'react';
import orionLogo from '../../images/orion/orion-logo-light.png';
import './styles.scss';

const ORION_HREF = 'https://orion.hexowatch.com/';

const OrionBanner = () => {
  return (
    <a className="orion-banner" href={ORION_HREF} aria-label="Try OR:ON, AI website monitoring">
      <div className="orion-banner__inner">
        <img className="orion-banner__logo" src={orionLogo} alt="Hexowatch OR:ON" />
        <span className="orion-banner__badge">New</span>
        <span className="orion-banner__text">AI website monitoring that explains every change</span>
        <span className="orion-banner__btn">Try OR:ON</span>
      </div>
    </a>
  );
};

export default OrionBanner;
